import type { PropsWithChildren } from 'react'
import { useEffect, useState } from 'react'

import { AnimatedChildrenContainer } from './AnimatedChildrenContainer'

import { gaSendEvent } from 'utils/helpers/analytics'

export type ScreenProps = PropsWithChildren & {
  gaEvent?: string
  className?: string
}

export function Screen({
  gaEvent,
  children,
  className,
}: ScreenProps): JSX.Element {
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    if (gaEvent) {
      gaSendEvent(gaEvent)
    }
    // Make sure the animations always run
    const tm = setTimeout(() => {
      setLoaded(true)
    }, 100)
    return () => clearTimeout(tm)
  }, [])

  return (
    <AnimatedChildrenContainer $show={loaded} className={className}>
      {children}
    </AnimatedChildrenContainer>
  )
}
